module.exports = __webpack_public_path__ + "static/projekte-ohiostrasse-10-6-6805d3a622e1b81fe4b77cd0799db4cc.jpg";